import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendFormDataRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';

export const useUploadVirtualMediaSequenceImagesMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, slug, files }: { playlistId: string; slug: string; files: File[] }) => {
      const token = await getToken();
      return uploadVirtualMediaSequenceImages(playlistId, slug, files, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
    },
  });
};

const uploadVirtualMediaSequenceImages = async (
  playlistId: string,
  slug: string,
  files: File[],
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/virtual-media/${encodeURIComponent(slug)}/images`;
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }
  return sendFormDataRequest({ url, method: METHOD.PUT, body: formData, token });
};
